import React, { createContext, useContext, useState } from 'react';

export interface PlatformEvent {
  id: string;
  category: 'deploys' | 'users' | 'billing' | 'infrastructure' | 'logs';
  title: string;
  description: string;
  workspaceName?: string;
  timestamp: string;
  status: 'success' | 'warning' | 'error' | 'info';
  linkTo?: string;
}

interface EventContextType {
  events: PlatformEvent[];
  loading: boolean;
  refreshEvents: () => Promise<void>;
  getEventsByCategory: (category: PlatformEvent['category']) => PlatformEvent[];
  getPulseState: (id: string) => 'green' | 'blue' | 'yellow' | 'red';
  getBadgeCount: (id: string) => number;
}

const EventContext = createContext<EventContextType | null>(null);

export function EventProvider({ children }: { children: React.ReactNode }) {
  const [events] = useState<PlatformEvent[]>([
    { id: '1', category: 'deploys', title: 'Deploy v4.8 concluído com sucesso', description: 'Ambiente de produção atualizado e testado.', workspaceName: 'Cyzor HQ', timestamp: 'Hoje, 14:00', status: 'success' },
    { id: '2', category: 'users', title: 'Novo usuário cadastrado', description: 'Ana Data ingressou no workspace.', workspaceName: 'Cyzor HQ', timestamp: 'Hoje, 11:30', status: 'info' },
    { id: '3', category: 'billing', title: 'Assinatura Pro renovada', description: 'Fatura de R$ 175.000,00 compensada.', workspaceName: 'Banco Horizon', timestamp: 'Ontem', status: 'success' },
    { id: '4', category: 'infrastructure', title: 'Cloud SQL operando normalmente', description: 'Latência média de 32ms.', workspaceName: 'Database Core', timestamp: 'Agora', status: 'success' },
    { id: '5', category: 'logs', title: 'Backup automático realizado', description: 'Snapshot diário gravado com sucesso.', workspaceName: 'Backup System', timestamp: 'Ontem', status: 'info' }
  ]);
  const [loading] = useState(false);

  const refreshEvents = async () => {};

  const getEventsByCategory = (category: PlatformEvent['category']) => {
    return events.filter(e => e.category === category);
  };

  const getPulseState = (): 'green' | 'blue' | 'yellow' | 'red' => 'green';
  const getBadgeCount = (): number => 2;

  return (
    <EventContext.Provider value={{ events, loading, refreshEvents, getEventsByCategory, getPulseState, getBadgeCount }}>
      {children}
    </EventContext.Provider>
  );
}

export function useEvents() {
  const context = useContext(EventContext);
  if (!context) {
    throw new Error('useEvents must be used within an EventProvider');
  }
  return context;
}
